<template>
    <Dropdown
        :modelValue="value"
        :options="options"
        filter
        resetFilterOnHide
        autoFilterFocus
        optionLabel="name"
        :placeholder="placeholder"
        :filterPlaceholder="filterPlaceholder"
        :id="`${this.id}-dropdown`"
    >
        <template #value="slotProps">
            <div v-if="slotProps.value">
                <div>{{ slotProps.value.name }}</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
        </template>
        <template #option="slotProps">
            <div class="country-item">
                {{ slotProps.option.name }}
                <i
                    class="pi pi-info-circle"
                    text-500
                    v-if="slotProps.option.desc"
                    v-tooltip="{ value: slotProps.option.desc }"
                    style="float: right"
                ></i>
            </div>
        </template>
    </Dropdown>
</template>

<script>
export default {
    name: 'StandardDropdown',
    props: ['value', 'options', 'placeholder', 'filterPlaceholder', 'filter', 'id'],
};
</script>

<style scoped />
